/**
 * Deprecated Need to improve it
 */
export class ContractUser {
	/**
	 * ContractUser class
	 * @property {number} contract_id - ID of a contract
	 * @property {number} user_id - ID of a user
	 * @property {number} contract_society_id - ID of a society
	 */
	constructor(contract_id, user_id, contract_society_id) {
		this.contract_id = contract_id;
		this.user_id = user_id;
		this.contract_society_id = contract_society_id;
	}
}
